import workspaceQuery from '../../queries/product/ProductWorkspaceQuery.graphql';
import listQuery from '../../queries/product/ProductListQuery.graphql';
import instanceQuery from '../../queries/product/ProductQuery.graphql';
import temporaryQuery from '../../queries/product/ProductTempQuery.graphql';
import defaultQuery from '../../queries/product/ProductDefault.graphql';
import mutationQuery from '../../mutations/product/ProductMutation.graphql';
import mutationTempQuery from '../../mutations/product/ProductTempMutation.graphql';
import aggregateQuery from '../../queries/product/ProductAggregateQuery.graphql';
import fragment from '../../fragments/product/ProductFragment.graphql';
import scanQuery from '../../queries/product/ProductBarcodeSearchQuery.graphql';
import multiListQuery from '../../queries/product/ProductMultiListQuery.graphql';
import React from 'react';
import { ProductOptionRenderer } from '../../../components/Product/ProductOptionRenderer';
import { EntityType } from '../../../@types/entityTypes';
import { FilterOperation, IFilterInput } from '../../schema/p4types';
import { productFormActionsForPermissions } from '../../../actions/product/ProductFormAction';
import { productWorkspaceActionsForPermissions } from '../../../actions/product/ProductWorkspaceAction';

export const maxMakeable = 0xffffffff;

export const getMultiQueryKeys = ({
  productFilters,
}: {
  productFilters?: Array<IFilterInput>;
}): Array<{
  title: string;
  valueKey: string;
  labelKey: string;
  predefinedFilters: Array<IFilterInput>;
  disabled?: boolean;
}> => {
  return [
    {
      title: 'Products',
      valueKey: 'id',
      labelKey: 'reference',
      predefinedFilters: [
        {
          filterOperation: FilterOperation.Custom,
          filterParameters: {
            field: 'template',
          },
        },
        ...(productFilters ?? []),
      ],
    },
    {
      title: 'Luckins Products',
      valueKey: 'id',
      labelKey: 'shortDescription',
      predefinedFilters: [
        {
          filterOperation: FilterOperation.Empty,
          filterParameters: {
            field: 'products',
          },
        },
      ],
      disabled: true,
    },
  ];
};

const Product: EntityType = {
  type: 'Product',
  title: 'Products',
  formTitle: 'Product',
  formUrl: '/Products/Product/Details/',
  workspaceUrl: '/Products/Product/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporary: temporaryQuery,
  temporaryUpdate: mutationTempQuery,
  notificationKey: 'reference',
  dropdown: {
    query: listQuery,
    scanQuery: scanQuery,
    valueKey: 'id',
    labelKey: 'reference',
    optionRenderer: ProductOptionRenderer,
    filterOption: () => true, //Override Default
    remoteFilter: true,
    placeholder: 'Search products',
    pageView: false,
    asButton: false,
    selectModal: 'ProductWorkspace',
    sidebarForm: 'ProductForm',
    multiQuery: {
      query: multiListQuery,
      keys: getMultiQueryKeys({}),
    },
    useLatestReactSelect: true,
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'PRODUCTS',
  actions: [...productWorkspaceActionsForPermissions, ...productFormActionsForPermissions],
  readOnlyStatus: [
    {
      key: 'preview',
      status: [true],
    },
  ],
};

export default Product;
